import React from 'react';
import { Helmet } from 'react-helmet';

// Google Search Console Verification Component
// This component adds the necessary meta tags for Search Console verification

interface SearchConsoleVerificationProps {
  googleSiteVerification?: string;
  bingSiteVerification?: string;
  yandexSiteVerification?: string;
}

const SearchConsoleVerification: React.FC<SearchConsoleVerificationProps> = ({
  googleSiteVerification = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION,
  bingSiteVerification = process.env.REACT_APP_BING_SITE_VERIFICATION,
  yandexSiteVerification = process.env.REACT_APP_YANDEX_SITE_VERIFICATION
}) => {
  return (
    <Helmet>
      {/* Google Search Console Verification */}
      {googleSiteVerification && (
        <meta name="google-site-verification" content={googleSiteVerification} />
      )}
      
      {/* Bing Webmaster Tools Verification */}
      {bingSiteVerification && (
        <meta name="msvalidate.01" content={bingSiteVerification} />
      )}
      
      {/* Yandex Webmaster Verification */}
      {yandexSiteVerification && (
        <meta name="yandex-verification" content={yandexSiteVerification} />
      )}
      
      {/* Additional Search Engine Optimization Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-video-preview:-1, max-image-preview:large, max-snippet:-1" />
      <meta name="bingbot" content="index, follow, max-video-preview:-1, max-image-preview:large, max-snippet:-1" />
      
      {/* Educational Institution Schema Hints */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="format-detection" content="address=yes" />
      
      {/* Additional SEO Meta Tags for Educational Institutions */}
      <meta name="application-name" content="TLC International School" />
      <meta name="apple-mobile-web-app-title" content="TLC International School" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="mobile-web-app-capable" content="yes" />
    </Helmet>
  );
};

export default SearchConsoleVerification;
